import * as React from "react";
import { Link } from "react-router-dom";
import * as Comp from "../../../../components";
import { ComponentWithValidatedForm } from "../../../../components/validation";
import { Paths } from "../../../../constants";
import * as Forms from "../../../../forms";
import * as M from "../../../../models";
import { Api } from "../../../../services/Api";

interface OwnProps {
    api: Api;
    abstract: M.Abstract.Abstract;
    eventId: number;
    type: M.Abstract.AbstractType;
    onSubmit: (model: Forms.AdminAbstract.AbstractDetailsData, body: any) => void;
}

interface OwnState {
}

export class DetailsForm extends ComponentWithValidatedForm<OwnProps, OwnState> {

    public constructor(props: any) {
        super(props);
        const formModel = new Forms.AdminAbstract.AbstractDetails();
        this.state = {
            ...this.getInitialState(formModel),
        };
    }

    public componentDidMount() {
        this.setFormData(this.props.type, this.props.abstract);
    }

    public setFormData(type: M.Abstract.AbstractType, abstract: M.Abstract.Abstract) {
        const formModel = this.getFormModel() as Forms.AdminAbstract.AbstractDetails;
        formModel.data.classificationId = abstract.classificationId || null;

        if (type.form) {
            formModel.data.classifications = type.classifications.length;
            M.FormBuilder.FormSubmissionHelper.setFormData(formModel.data, type.form, abstract.details);

            // make sure the chosen classification ID is valid for the abstract type.
            // if not, set value to null.
            if (type.classifications.map((x) => x.id).indexOf(formModel.data.classificationId || 0) === -1)
                formModel.data.classificationId = null;

            this.updateFormModel(formModel);
        }
    }

    public render() {
        const formModel = this.getFormModel() as Forms.AdminAbstract.AbstractDetails;
        const cancelLink = Paths.AdminAbstractDetails(this.props.eventId, this.props.abstract.guid);
        const fieldSections = formModel.data.sections.map((s, i) => <Comp.FormBuilder.FieldSection
                formComponent={this}
                key={i}
                section={s}
            />);

        const classifications: M.Editors.SelectItem[] = this.props.type
            ? this.props.type.classifications.map((x) => ({
                id: x.id,
                render: x.name,
            }))
            : [];

        const classificationField = classifications.length
            ? <Comp.Editors.DropdownField formComponent={this} name="classificationId" items={classifications} placeholder="Select..." required />
            : null;

        if (!fieldSections.length && !classifications.length) {
            return <>
                <p>No details required for type <strong>{this.props.type.name}</strong>.</p>
                <ul>
                    <li><Link to={Paths.AdminAbstractEdit(this.props.eventId, this.props.abstract.guid)}>Edit authorship &raquo;</Link></li>
                    <li><Link to={Paths.AdminAbstractEditUploads(this.props.eventId, this.props.abstract.guid)}>Edit uploads &raquo;</Link></li>
                    <li><Link to={Paths.AdminAbstractEditPermissions(this.props.eventId, this.props.abstract.guid)}>Edit permissions &raquo;</Link></li>
                    <li><Link to={Paths.AdminAbstractEditSettings(this.props.eventId, this.props.abstract.guid)}>Edit admin settings &raquo;</Link></li>
                </ul>
            </>;
        }

        return <Comp.Validation.ValidatedForm
            formComponent={this}
            model={this.state.formModel.data}
            onCustomValidation={() => this.handleFormBuilderValidation()}
            onValidSubmit={async (model) => this.handleSubmit(model)}
            schema={this.state.formModel.rules}
            ref={(ref: any) => this.form = ref}
        >
            {classificationField}

            {fieldSections}

            <Comp.Editors.SubmitField cancelLink={cancelLink} label="Save" showProcessing={this.state.formProcessing} />

        </Comp.Validation.ValidatedForm>;
    }

    private handleFormBuilderValidation() {
        if (this.props.type && this.props.type.form)
            return M.FormBuilder.FormSubmissionHelper.validateSubmission(this, this.props.type.form, this.state.formModel.data);
        return [];
    }

    private handleSubmit(model: Forms.AdminAbstract.AbstractDetailsData) {
        const body = {
            ...M.FormBuilder.FormSubmissionHelper.getPostBody(model),
            classificationId: model.classificationId,
            guid: this.props.abstract.guid,
        };

        this.props.onSubmit(model, body);
    }
}



// WEBPACK FOOTER //
// ./src/containers/adminAbstracts/edit/components/DetailsForm.tsx